import React, { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { config } from '../config';
import packageJson from '../../package.json';
import { Snackbar } from 'components/ui/Feedback';

const { version } = packageJson;

const VERSION_CHECK_INTERVAL_MS = 5 * 60 * 1000;
const INACTIVITY_MS = 20 * 60 * 1000;

export const VersionChecker = () => {
    const [interval, setIntervalValue] = useState<NodeJS.Timeout | undefined>(
        undefined
    );
    const [isNewVersion, setIsNewVersion] = useState(false);

    const checkVersion = () => {
        fetch(`${config.serverUrl}/version`, {
            method: 'POST', // to prevent caching
        })
            .then((r) => r.json())
            .then((r) => {
                if (r.version !== version) {
                    stopPoll();
                    const path = window.location.pathname;
                    if (
                        path.indexOf('/add') > 0 ||
                        path.indexOf('/edit/') > 0
                    ) {
                        setIsNewVersion(true);
                    } else {
                        window.location.reload();
                    }
                }
            })
            .catch((e) => {});
    };
    const stopPoll = () => {
        if (interval) {
            clearInterval(interval);
        }
    };
    const poll = () => {
        stopPoll();
        const newInterval = setInterval(
            checkVersion,
            VERSION_CHECK_INTERVAL_MS
        );
        setIntervalValue(newInterval);
        checkVersion();
    };
    const idle = useIdleTimer({
        timeout: INACTIVITY_MS,
        onIdle: poll,
        onAction: stopPoll,
    });

    useEffect(() => {
        return () => {
            idle?.pause();
            stopPoll();
        };
    }, []);

    if (isNewVersion) {
        return (
            <Snackbar
                open
                onUndo={() => window.location.reload()}
                undoLabel="Refresh"
                message="A new version of Neon Insights has been released. Please refresh the page to update."
            />
        );
    }

    return <></>;
};
